import styled, { css } from 'styled-components';

import Card from '@components/Card';

const Container = styled(Card)`
  padding: ${({ theme }) => theme.spacing(6)};
  position: relative;
  &:last-of-type {
    margin-bottom: 24px;
  }
  align-items: center;

  ${({ withWarning }) =>
    withWarning &&
    css`
      border: 1px solid ${({ theme }) => theme.colors.red_darker_3};
    `}

  ${({ align }) =>
    align &&
    css`
      align-items: flex-start;
    `}
`;

export default Container;
